<div class="mb-3">
  <div fxLayoutAlign="space-between center">
    <h1 mat-dialog-title>{{ edit ? 'Redigere' : 'Opret' }} integrations bruger</h1>
    <button class="mr-3" mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <mat-divider></mat-divider>
</div>
<div mat-dialog-content [formGroup]="form">
  <mat-form-field color="primary" class="mr-3">
    <mat-label>Navn</mat-label>
    <input matInput type="text" formControlName="username">
  </mat-form-field>
  <mat-form-field color="primary">
    <mat-label>Kode</mat-label>
    <input matInput formControlName="password">
  </mat-form-field>
  <div fxLayout="row" fxLayoutAlign="start center">
    <label>IP adresser</label>
    <button mat-icon-button (click)="addIpAddress()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <div fxLayout="row wrap">
    @for (ipAddress of form.controls.ip_addresses.controls; track ipAddress; let i = $index) {
      <div class="mr-3">
        <mat-form-field color="primary">
          <mat-label>IP adresse</mat-label>
          <input matInput type="text" [formControl]="ipAddress">
        </mat-form-field>
        <button mat-icon-button (click)="removeIpAddress(i)">
          <mat-icon >remove</mat-icon>
        </button>
      </div>
    }
  </div>
  <ng-container formGroupName="permissions">
    @for (keyValue of recordsPermission | keyvalue; track keyValue) {
      <mat-form-field class="mr-3"
        formGroupName="records"

        >
        <mat-label>{{keyValue.key}}</mat-label>
        <mat-select [formControlName]="keyValue.key" multiple>
          @for (value of keyValue.value; track value) {
            <mat-option
              [value]="value"
            >{{value}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field
      floatLabel="always"

      class="underline-none"
      formGroupName="posting"
      >
      <mat-label>Redigere posteringer</mat-label>
      <mat-slide-toggle formControlName="manage"></mat-slide-toggle>
      <textarea matInput hidden></textarea>
    </mat-form-field>
  </ng-container>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-flat-button (click)="confirm()" [disabled]="form.invalid" color="primary">
    {{edit ? 'Gem' : 'Opret'}}
  </button>
</div>
